import { render } from "./ModalOverlay.vue?vue&type=template&id=58ee07a8&scoped=true"
import script from "./ModalOverlay.vue?vue&type=script&lang=js"
export * from "./ModalOverlay.vue?vue&type=script&lang=js"

import "./ModalOverlay.vue?vue&type=style&index=0&id=58ee07a8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexty-frontend/nexty-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ee07a8"]])

export default __exports__